module.exports = __webpack_public_path__ + "img/callendar.0bd7abd0.svg";